export const extractTrailingSlashFromPath = (path: string): string => path.replace(/\/$/, '');
